// extracted by mini-css-extract-plugin
export var buttons = "_bf-0";
export var buttonsActive = "_bf-h";
export var cancelConfirm = "_bf-1";
export var closeButton = "_bf-2";
export var column = "_bf-3";
export var container = "_bf-4";
export var detailHeader = "_bf-6";
export var detailTitle = "_bf-7";
export var detailsContent = "_bf-5";
export var header = "_bf-8";
export var headerWithClose = "_bf-9";
export var icon = "_bf-a";
export var infoIcon = "_bf-c";
export var informationContainer = "_bf-b";
export var sideDrawer = "_bf-d";
export var sideDrawerOpen = "_bf-e";
export var stickyFooter = "_bf-f";
export var typeOption = "_bf-g";